import { I18nAndL10n } from '@application/i18n/i18n_and_l10n';
import { withTranslation } from '@application/i18n/with_translation';
import { Button } from '@cellula/react';
import { ErrorInterrupted } from '@component/error_interrupted.component';
import { Link } from 'react-router-dom';

export function FlowError(): JSX.Element {
	return (
		<ErrorInterrupted
			title={withTranslation('View.Guest.ErrorInterrupted.Title')}
			body={I18nAndL10n.translate('View.Guest.ErrorInterrupted.Body')}
		>
			<Button as={Link} to='./error'>
				{withTranslation('View.Guest.ErrorInterrupted.Button')}
			</Button>
		</ErrorInterrupted>
	);
}
